import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {HeaderComponent} from "./component/header/header.component";
import {FooterComponent} from "./component/footer/footer.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BodyComponent} from './component/body/body.component';
import {SiteListComponent} from "./component/site-list/site-list.component";
import {HttpClientModule} from "@angular/common/http";
import { ResultsComponent } from './component/body/results/results.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    BodyComponent,
    SiteListComponent,
    ResultsComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
